import { render, staticRenderFns } from "./sms-template.vue?vue&type=template&id=66f744a1"
import script from "./sms-template.vue?vue&type=script&lang=js"
export * from "./sms-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports